<template>
  <v-container>
    <v-row class="mt-6" justify="center" no-gutters>
      <v-col lg="8">
        <v-card flat class="ma-3 pa-4">
          <v-container>
            <v-form ref="form" class="mt-6">
              <v-row class="mt-3" justify="center" no-gutters>
                <v-col cols="12" xl="6" lg="6" md="12" sm="12">
                  <v-card flat>
                    <v-card-title class="text-center justify-center py-">
                      <div class="text-h4 mt-5" style="display: block">
                        {{ $t('register.title')}}
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <FormOtp v-if="state == 'requestOtp'" @sent="otpSent" />
                      <FormRegister v-if="state == 'confirmOtp'" :phoneNumber="phoneNumber" />
                      <h4><span>Or</span></h4>
                      <v-container>
                        <v-row class="mt-0" justify="center">
                          <v-btn text class="title" to="/auth/login">
                            {{ $t('register.login') }}
                          </v-btn>
                        </v-row>
                        <v-row class="mt-15" justify="center">
                          <v-btn text class="subtitle-2"
                            target="_blank"
                            href="https://www.suidlanders.co.za/termsandconditions/">
                            {{ $t('login.tos') }}
                          </v-btn>
                          <a href="#"></a>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiOpenInNew } from '@mdi/js';
import FormOtp from '../components/FormOtp.vue';
import FormRegister from '../components/FormRegister.vue';

export default {
  components: { FormOtp, FormRegister },
  name: 'Register',
  data() {
    return {
      mdiOpenInNew,
      state: 'requestOtp',
      phoneNumber: undefined,
    };
  },
  methods: {
    otpSent(form) {
      this.phoneNumber = form.phoneNumber;
      this.state = 'confirmOtp';
    },
  },
};
</script>
<style>
h4 {
   width: 100%;
   text-align: center;
   border-bottom: 1px solid #000;
   line-height: 0.1em;
   margin: 10px 0 20px;
}

h4 span {
    background:#fff;
    padding:0 10px;
}
</style>
